import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaStickyNote, FaUser, FaClock } from "react-icons/fa";
import Task from "./Task";
import InteractionRecord from "./InteractionRecord";
import Service from "./Service";
import Purchase from "./Purchase";
import Quotation from "./Quotation";
import Invoice from "./Invoice";
import Status from "./Status";
import { path_url } from "../../Config/config";
import Proforma from "./Proforma";
import { useNavigate } from "react-router-dom";
import UserFooter from "../UserFooter";
import "../../Style/NewVendor.css";
const customerSchema = Yup.object().shape({
  product: Yup.string().required("Required"),
  preferences: Yup.string().required("Required"),
  status: Yup.string().required("Required"),
  notes: Yup.string(),
  direction: Yup.string().required("Required"),
});

function CustomerDetails({
  Details,
  refetchDetails,
  onOpenPurchaseModal,
  onOpenProformaModal,
  onOpenServiceModal,
  onOpenInteractionModal,
}) {
  const navigate = useNavigate();

  // const vendorId = Details?.vendor?.id || "default_vendor_id";

  const [customerId, setCustomerId] = useState("");
  useEffect(() => {
    // Ensure Details is not null and contains the vendor object
    if (Details && Details.customer && Details.customer.id) {
      setCustomerId(Details.customer.id); // Update the vendorId state
    }
    setExtraNotes([]);
  }, [Details]);
  const options = [
    { value: "Inbound", label: "Inbound" },
    { value: "Outbound", label: "Outbound" },
  ];

  const options1 = [
    { value: "Emergency", label: "Emergency" },
    { value: "High", label: "High" },
    { value: "Low", label: "Low" },
    { value: "Medium", label: "Medium" },
    { value: "Normal", label: "Normal" },
    { value: "Deferred", label: "Deferred" },
    { value: "Critical", label: "Critical" },
  ];

  const options2 = [
    { value: "Close", label: "Close" },
    { value: "Open", label: "Open" },
  ];
  const options3 = [
    { value: "Inbound", label: "Inbound" },
  ];

  // ── Notes state ──────────────────────────────────────────────
  // Load notes from backend data (Details.eventList.notesList),
  // falling back to interaction records that carry note text.
  const [extraNotes, setExtraNotes] = useState([]);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [newNoteText, setNewNoteText] = useState("");
  const [noteSubmitting, setNoteSubmitting] = useState(false);

  // Derive persisted notes from backend data
  const backendNotes = (
    Details?.eventList?.notesList ||
    (Details?.eventList?.interactionRecordList || []).filter(
      (r) => r.notes || r.remarks || r.description || r.enquiry
    )
  ).map((r) => {
    let author = r.createdBy || r.author || "System";
    if (author === localStorage.getItem("userId")) {
      author = localStorage.getItem("name") || "You";
    }
    return {
      id: r.id || r.noteId,
      author,
      content: r.notes || r.content || r.remarks || r.description || r.enquiry || "",
      createdDate: r.createdAt
        ? new Date(r.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        : r.createdDate || "",
      updatedDate: r.updatedAt
        ? new Date(r.updatedAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        : r.updatedDate || null,
    };
  });

  // Combined: local optimistic additions first, then backend notes
  const notesList = [...extraNotes, ...backendNotes];

  const handleAddNote = async () => {
    if (!newNoteText.trim()) return;
    setNoteSubmitting(true);
    const token = localStorage.getItem("accessToken");
    const adminId = localStorage.getItem("adminId");
    const targetCustomerId = Details?.customer?.id || customerId || "";
    const now = new Date();
    const formatted = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const payload = {
      enquiry: newNoteText.trim(),
      ...(targetCustomerId ? { customerid: targetCustomerId } : {}),
      useradminid: adminId,
      usercid: adminId,
      direction: "Inbound",
      status: "Close",
      priority: "Normal",
      product: "CRM",
    };
    try {
      const response = await axios.post(`${path_url}/interactionrecord`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response.data.statusCodeValue === 200 || response.status === 200) {
        toast.success("Note added successfully");
        setExtraNotes((prev) => [
          { id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null },
          ...prev,
        ]);
        setNewNoteText("");
        if (typeof refetchDetails === "function") refetchDetails();
      } else {
        setExtraNotes((prev) => [
          { id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null },
          ...prev,
        ]);
        setNewNoteText("");
        toast.warning("Note saved locally. Backend sync pending.");
      }
    } catch {
      setExtraNotes((prev) => [
        { id: Date.now(), author: "You", content: newNoteText.trim(), createdDate: formatted, updatedDate: null },
        ...prev,
      ]);
      setNewNoteText("");
      toast.warning("Note saved locally. Check your connection.");
    } finally {
      setNoteSubmitting(false);
    }
  };
  // ─────────────────────────────────────────────────────────────

  return (
    <div>
      <Formik
        enableReinitialize={true}
        initialValues={{
          preferences: "Emergency",
          product: "CRM",
          status: "Close",
          direction: "Outbound",
          notes: "",
          customerid: customerId || Details?.customer?.id || "",
        }}
        validationSchema={customerSchema}
        onSubmit={async (values) => {
          try {
            const token = localStorage.getItem("accessToken");
            const adminId = localStorage.getItem("adminId");
            const targetCustomerId = customerId || Details?.customer?.id || "";
            const payload = {
              ...values,
              priority: values.preferences || values.priority || "Emergency",
              enquiry: values.notes || values.enquiry || "",
              direction: values.direction || "Outbound",
              status: values.status || "Close",
              product: values.product || "CRM",
              useradminid: adminId,
              usercid: adminId,
              ...(targetCustomerId ? { customerid: targetCustomerId } : {}),
            };
            const response = await axios.post(
              `${path_url}/interactionrecord`,
              payload,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              },
            );
            if (
              response.data.statusCodeValue === 200 ||
              response.status === 200 ||
              response.status === 201
            ) {
              toast.success("Interaction record submitted successfully");
              // Refresh data so new records appear immediately
              if (typeof refetchDetails === "function") refetchDetails();
            } else {
              toast.error(response.data.body || "Failed to save record");
            }
          } catch (errors) {
            console.error("Error submitting interaction record:", errors);
            toast.error("Failed to submit interaction record");
          }
        }}
      >
        {(formik) => (
          <form action="" onSubmit={formik.handleSubmit}>
            <fieldset
              style={{ paddingLeft: "5px", width: "98%", marginBottom: "5rem" }}
            >
              <div className=" mt-3">
                <div className="row">
                  {/* ── Interaction Record Panel ── */}
                  <div className="col-lg-6 mb-3" id="contact-section">
                    <div className="ir-notes-panel">
                      <div className="ir-notes-panel-title">
                        📋 Interaction Record
                      </div>

                      <div className="ir-field">
                        <label className="form-label">Direction</label>
                        <select
                          className="form-select form-select-sm"
                          name="direction"
                          id="direction"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.direction}
                        >
                          <option value="Outbound">Outbound</option>
                          {options3.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </select>
                      </div>

                      <div className="ir-grid-2">
                        <div>
                          <label className="form-label">Status</label>
                          <select
                            className="form-select form-select-sm"
                            name="status"
                            id="status"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.status}
                          >
                            <option value="Close">Close</option>
                            {options2.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                          </select>
                        </div>
                        <div>
                          <label className="form-label">Priority</label>
                          <select
                            className="form-select form-select-sm"
                            name="preferences"
                            id="priority"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.preferences}
                          >
                            <option value="Emergency">Emergency</option>
                            {options1.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                          </select>
                        </div>
                      </div>

                      <div className="ir-field">
                        <label className="form-label">Product</label>
                        <select
                          className="form-select form-select-sm"
                          name="product"
                          id="product"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.product}
                        >
                          <option value="CRM">CRM</option>
                          {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
                        </select>
                      </div>

                      <div className="ir-field" style={{ flex: 1 }}>
                        <label className="form-label">Notes</label>
                        <textarea
                          className="form-control form-control-sm"
                          id="notes"
                          name="notes"
                          rows={3}
                          placeholder="Enter interaction notes..."
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.notes}
                          style={{ resize: "none" }}
                        />
                      </div>

                      <div className="text-end mt-2">
                        <button type="submit" className="btn btn-sm btn-info text-white px-4">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* ── Notes Panel ── */}
                  <div className="col-lg-6 mb-3">
                    <div className="ir-notes-panel">
                      <div className="notes-section-header">
                        <FaStickyNote style={{ color: "#0dcaf0" }} />
                        Notes
                      </div>

                      {/* Scrollable notes list */}
                      <div className="notes-list">
                        {notesList.length === 0 ? (
                          <p className="notes-empty">No notes yet. Write below to add your first note.</p>
                        ) : (
                          notesList.map((note) => (
                            <div key={note.id} className="note-card">
                              <div className="note-card-header">
                                <span className="note-card-author">
                                  <FaUser className="me-1" style={{ fontSize: "0.72rem" }} />
                                  {note.author}
                                </span>
                                <span className="note-card-date">
                                  <FaClock className="me-1" style={{ fontSize: "0.68rem" }} />
                                  {note.createdDate}
                                </span>
                              </div>
                              <div className="note-card-body">
                                <div className="note-card-content">{note.content}</div>
                                {note.updatedDate && (
                                  <div className="note-card-updated">Last Updated: {note.updatedDate}</div>
                                )}
                              </div>
                            </div>
                          ))
                        )}
                      </div>

                      {/* Inline composer — always visible */}
                      <div className="note-composer">
                        <textarea
                          placeholder="Write a note and click Save…"
                          value={newNoteText}
                          onChange={(e) => setNewNoteText(e.target.value)}
                          disabled={noteSubmitting}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) handleAddNote();
                          }}
                        />
                        <div className="note-composer-actions">
                          <button
                            type="button"
                            className="note-save-btn"
                            onClick={handleAddNote}
                            disabled={noteSubmitting || !newNoteText.trim()}
                          >
                            {noteSubmitting ? "Saving…" : "Save Note"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ── Task Card ── */}
              <div className="col-12 mt-4" id="task-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#e0f2fe" }}
                      >
                        <i className="fas fa-tasks text-primary" style={{ fontSize: "0.95rem" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Tasks</h6>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        navigate("/create-task", {
                          state: {
                            customerId: customerId || Details?.customer?.id,
                            customerData: Details?.customer,
                          },
                        });
                      }}
                      className="btn btn-sm btn-outline-primary px-3 py-1 rounded-pill fw-medium bg-white"
                      style={{ fontSize: "0.82rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Task
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <Task tableData={Details?.eventList?.taskList} />
                  </div>
                </div>
              </div>

              {/* ── Interaction Record Card ── */}
              <div className="col-12 mt-4" id="interaction-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#ecfeff" }}
                      >
                        <i className="fas fa-comments text-info" style={{ fontSize: "0.95rem" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Interaction Records</h6>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        if (typeof onOpenInteractionModal === "function") {
                          onOpenInteractionModal();
                        } else {
                          const el = document.getElementById("contact-section");
                          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                          const notesField = document.getElementById("notes");
                          if (notesField) notesField.focus();
                        }
                      }}
                      className="btn btn-sm btn-outline-info px-3 py-1 rounded-pill fw-medium bg-white"
                      style={{ fontSize: "0.82rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Record
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <InteractionRecord
                      tableData={Details?.eventList?.interactionRecordList}
                      customerName={`${Details?.customer?.firstName || ""} ${Details?.customer?.lastName || ""}`.trim() || Details?.customer?.companyname || ""}
                    />
                  </div>
                </div>
              </div>

              {/* ── Service Request Card ── */}
              <div className="col-12 mt-4" id="service-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#fef3c7" }}
                      >
                        <i className="fas fa-concierge-bell text-warning" style={{ fontSize: "0.95rem" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Service Requests</h6>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        if (typeof onOpenServiceModal === "function") {
                          onOpenServiceModal();
                        } else {
                          const el = document.getElementById("service-section");
                          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                        }
                      }}
                      className="btn btn-sm btn-outline-warning px-3 py-1 rounded-pill fw-medium bg-white text-dark"
                      style={{ fontSize: "0.82rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Request
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <Service tableData={Details?.eventList?.serviceRequestList} />
                  </div>
                </div>
              </div>

              {/* ── Invoice Card ── */}
              <div className="col-12 mt-4" id="invoice-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#dcfce7" }}
                      >
                        <i className="fas fa-file-invoice text-success" style={{ fontSize: "0.95rem" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Invoices</h6>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        navigate("/create-invoice", {
                          state: {
                            customerId: customerId || Details?.customer?.id,
                            customerData: Details?.customer,
                          },
                        });
                      }}
                      className="btn btn-sm btn-outline-success px-3 py-1 rounded-pill fw-medium bg-white"
                      style={{ fontSize: "0.82rem" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Invoice
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <Invoice tableData={Details?.eventList?.invoicesList} />
                  </div>
                </div>
              </div>

              {/* ── Purchase Order Card ── */}
              <div className="col-12 mt-4" id="purchase-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#f3e8ff" }}
                      >
                        <i className="fas fa-shopping-cart" style={{ fontSize: "0.95rem", color: "#7c3aed" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Purchase Orders</h6>
                    </div>
                    <button
                      type="button"
                      type="button"
                      onClick={() => {
                        navigate("/create-purchase-order", {
                          state: { customer: Details?.customer },
                        });
                      }}
                      className="btn btn-sm btn-outline-secondary px-3 py-1 rounded-pill fw-medium bg-white"
                      style={{ fontSize: "0.82rem", borderColor: "#7c3aed", color: "#7c3aed" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Purchase Order
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <Purchase tableData={Details?.eventList?.orderList} />
                  </div>
                </div>
              </div>

              {/* ── Proforma Invoice Card ── */}
              <div className="col-12 mt-4" id="proforma-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#fffbeb" }}
                      >
                        <i className="fas fa-file-invoice-dollar" style={{ fontSize: "0.95rem", color: "#d97706" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Proforma Invoices</h6>
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        if (typeof onOpenProformaModal === "function") {
                          onOpenProformaModal();
                        }
                      }}
                      className="btn btn-sm btn-outline-warning px-3 py-1 rounded-pill fw-medium bg-white text-dark"
                      style={{ fontSize: "0.82rem", borderColor: "#d97706" }}
                    >
                      <i className="fas fa-plus me-1"></i> Create Proforma Invoice
                    </button>
                  </div>
                  <div className="card-body p-0">
                    <Proforma />
                  </div>
                </div>
              </div>

              {/* quatation  */}

              <div className="col-12 d-flex justify-content-center">
                <div className="bg-white col-12 mt-3">
                  <div className="d-flex justify-content-right">
                    <div className="bg-info col-12 m-1 mt-3 rounded shadow-sm elevation-2 pt-1"></div>
                  </div>

                  <div
                    className="d-flex justify-content-between"
                    style={{
                      paddingBottom: 2,
                      paddingTop: 10,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <label
                      className="ml-6 pt-2 m-0"
                      style={{ fontWeight: "700" }}
                    >
                      Quotation
                    </label>
                    <button
                      type="button"
                      onClick={() => {
                        navigate("/create-quotation", {
                          state: { customer: Details?.customer },
                        });
                      }}
                      className="btn btn-sm border btn-info"
                    >
                      Create Quotation
                    </button>
                  </div>

                  <div className="d-flex ">
                    <div className="col-12 ">
                      <div className="col-12 d-flex m-2 mb-3">
                        <div className="col-4 d-flex justify-content-start">
                          <label
                            htmlFor=""
                            className="m-0 p-0"
                            style={{ fontSize: 15 }}
                          >
                            <simple>Show</simple>
                          </label>

                          <div className="col-5">
                            <Field
                              as="select"
                              name="status"
                              id="status"
                              className="border w-100 pl-2"
                            >
                              <option value="number">10</option>
                              {options2.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Field>
                            {formik.touched.status && formik.errors.status && (
                              <span style={{ color: "red" }}>
                                {formik.errors.status}
                              </span>
                            )}
                          </div>

                          <div className="col-4 d-flex justify-content-start">
                            <label
                              htmlFor=""
                              className="m-0 p-0"
                              style={{ fontSize: 15 }}
                            >
                              <simple>entries</simple>
                            </label>
                          </div>
                        </div>
                      </div>
                      <Quotation />
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <Quotation />
                  </div>
                </div>
              </div>

              {/* ── Status History Card ── */}
              <div className="col-12 mt-4" id="status-section">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-flex align-items-center justify-content-center rounded-circle me-2"
                        style={{ width: 34, height: 34, background: "#f8fafc" }}
                      >
                        <i className="fas fa-history text-muted" style={{ fontSize: "0.95rem" }}></i>
                      </span>
                      <h6 className="mb-0 fw-semibold" style={{ fontSize: "0.95rem", color: "#0f172a" }}>Status History</h6>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <Status leadId={customerId} type="customer" />
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </Formik>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </div>
  );
}

export default CustomerDetails;
